var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLyceum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 3000 3000"
    },
    xmlSpace: "preserve",
    viewBox: "350 1096.25 2300 807.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000016038012959076371210000001306607558675176379_);}\n\t.st2{fill:url(#SVGID_00000110458944903507028290000016970401604726508947_);}\n\t.st3{fill:url(#SVGID_00000016790379532829891940000005678797144716711829_);}\n\t.st4{fill:#353535;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 823.4905,
    y1: 1114.2452,
    x2: 320.1551,
    y2: 1827.561
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE8C00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F83600"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M695.06,1096.25H421.52c-10.94,0-19.81,8.87-19.81,19.81V1222c-21.76,8.52-39.27,23.51-50.35,43.62    c-3.11,5.65-0.67,12.75,5.31,15.15l0.49,0.2c4.98,2,10.71,0.02,13.29-4.69c9.48-17.36,24.9-29.68,44.51-35.87    c8.9-2.39,18.66-3.86,29.38-4.17c38.93-59.02,148.52-43.19,187.85-13.89c-7.02,2.16-13.53,4.84-19.39,7.88    c-25.15,13.06-42.62,33.84-48.05,56.26c-1.65,6.82,3.33,13.44,10.34,13.6c5.1,0.12,9.69-3.28,10.85-8.24    c3.82-16.38,17.31-32.02,36.94-42.2c30.39-15.78,65.74-14.74,96.05,2.44c36.61,22.17,71.95,59.4,78.18,106.65    c-4.64-2.93-9.6-5.49-14.89-7.65c-31.12-12.67-67.68-8.34-93.2,10.07c-5.42,3.91-6,11.78-1.29,16.52    c3.81,3.84,9.83,4.27,14.21,1.1c19.5-14.1,47.78-17.31,72.03-7.44c13.79,5.62,35.36,19.42,42.88,51.87    c6.56,38.37,1.07,89.24-47.62,127.96c2.33-24.54-4.35-49.47-18.81-67.93c4.79-17.48,2.24-36.55-6.62-51.34    c-3.59-5.98-11.9-6.92-16.85-2c-3.55,3.53-4.4,9.05-1.84,13.35c6.57,11.02,7.8,26.23,2.59,39.02    c-3.46,8.5-12.37,22.16-34.36,25.48c-5.3,0.8-9.15,5.48-9.07,10.84l0,0.21c0.1,6.59,6.02,11.54,12.53,10.53    c17.79-2.76,32.39-10.96,42.33-23.61c10.28,18.91,11.81,43.57,3.06,65.06c-6.59,16.19-24.47,43.11-70.58,45.41    c-0.52,0.03-1.05-0.02-1.55-0.14c-0.01,0-0.02-0.01-0.04-0.01c-1.92-0.46-3.95,0.15-5.25,1.64c-5.78,6.62-20.11,27.22-16.26,65.3    h46.56c162.02,0,293.35-131.34,293.35-293.35v0v0C988.42,1227.59,857.08,1096.25,695.06,1096.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117669470795065209690000010104221804220358024_",
    gradientUnits: "userSpaceOnUse",
    x1: 877.0928,
    y1: 1152.0686,
    x2: 373.7574,
    y2: 1865.3844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE8C00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F83600"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000117669470795065209690000010104221804220358024_)"
    },
    d: "M600.67,1583.05    c-17.76-5.94-41.34-25.73-49.6-45.03c21.82-4.04,40.34-14.45,52.03-29.22c4.33-5.47,2.54-13.55-3.73-16.63h0    c-4.58-2.25-10.17-1.09-13.3,2.93c-10.34,13.26-29.15,21.79-51.24,22.8c-7.39,0.34-14.66-0.15-21.73-1.38    c-49.29-10.94-72.8-47.88-69.55-58.1c-16-2.27-29.85-5.73-41.85-10v234.54v200.98c0,10.94,8.87,19.81,19.81,19.81h181.17    c10.94,0,19.81-8.87,19.81-19.81v-200.98C617.3,1645.82,589.8,1621.9,600.67,1583.05z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097492279995476609030000009253591212484403134_",
    gradientUnits: "userSpaceOnUse",
    x1: 685.9921,
    y1: 1017.2227,
    x2: 182.6567,
    y2: 1730.5385
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE8C00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F83600"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097492279995476609030000009253591212484403134_)"
    },
    d: "M403.62,1371.85    c5.09,0,9.47-3.52,10.64-8.47c3.37-14.33,14.88-27.85,29.82-34.04c18.32-7.6,38.29-3.26,57.01,12.17    c4.32,3.56,10.66,3.2,14.61-0.76c4.57-4.57,4.18-12.1-0.82-16.2c-24.99-20.48-53.33-26.14-79.19-15.41    c-21.59,8.95-37.79,28.16-42.74,49.3c-1.6,6.85,3.62,13.41,10.66,13.41H403.62z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091002270250538698050000011123534965117123480_",
    gradientUnits: "userSpaceOnUse",
    x1: 808.5835,
    y1: 1103.7264,
    x2: 305.2481,
    y2: 1817.0422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE8C00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F83600"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091002270250538698050000011123534965117123480_)"
    },
    d: "M598.67,1383.47    c-20.78-4.25-42.09,3.04-57,19.48c-4.06,4.47-3.72,11.39,0.75,15.45c4.47,4.06,11.39,3.72,15.45-0.75    c9.67-10.66,23.28-15.43,36.42-12.74c11.07,2.26,19.4,9.28,22.86,19.27c1.57,4.52,5.8,7.36,10.33,7.36c1.19,0,2.4-0.2,3.58-0.61    c5.71-1.98,8.73-8.21,6.75-13.91C631.85,1399.8,617.22,1387.26,598.67,1383.47z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1124.04,1216.96h60.38c36.74,0,60.38,24.01,60.38,60.75v29.83c0,36.74-23.64,60.75-60.38,60.75h-21.83     v103.31h-38.56V1216.96z M1182.6,1331.91c14.91,0,23.64-8.73,23.64-23.64v-31.28c0-14.91-8.73-23.64-23.64-23.64h-20.01v78.57     H1182.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1277.18,1471.6v-254.63h38.56v107.31h45.84v-107.31h38.56v254.63h-38.56v-110.95h-45.84v110.95H1277.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1442.33,1216.96h38.56v254.63h-38.56V1216.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1523.08,1216.96h38.56v218.26h68.75v36.38h-107.31V1216.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1656.94,1413.76V1274.8c0-36.74,24.74-61.48,61.84-61.48c37.1,0,61.84,24.74,61.84,61.48v138.96     c0,36.74-24.74,61.48-61.84,61.48C1681.68,1475.24,1656.94,1450.5,1656.94,1413.76z M1742.06,1413.76V1274.8     c0-16.01-9.09-25.1-23.28-25.1c-14.19,0-23.28,9.09-23.28,25.1v138.96c0,16,9.09,25.1,23.28,25.1     C1732.97,1438.86,1742.06,1429.76,1742.06,1413.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1810.81,1412.67v-9.09l37.1-4v9.46c0,18.55,9.46,29.83,24.74,29.83c15.28,0,24.74-9.46,24.74-24.37     c0-16.01-6.55-27.65-35.29-54.93c-38.2-36.01-49.11-55.66-49.11-83.67c0-37.83,21.83-62.57,58.57-62.57s58.57,24.74,58.57,62.93     v6.55l-37.1,4v-7.27c0-19.64-7.64-29.83-21.1-29.83c-13.46,0-21.1,8.37-21.1,24.37c0,16,8,27.65,35.29,54.93     c37.1,37.1,49.11,55.66,49.11,83.67c0,36.38-25.46,62.57-62.2,62.57C1836.27,1475.24,1810.81,1449.04,1810.81,1412.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1964.68,1413.76V1274.8c0-36.74,24.74-61.48,61.84-61.48c37.1,0,61.84,24.74,61.84,61.48v138.96     c0,36.74-24.74,61.48-61.84,61.48C1989.42,1475.24,1964.68,1450.5,1964.68,1413.76z M2049.8,1413.76V1274.8     c0-16.01-9.09-25.1-23.28-25.1c-14.19,0-23.28,9.09-23.28,25.1v138.96c0,16,9.09,25.1,23.28,25.1     C2040.71,1438.86,2049.8,1429.76,2049.8,1413.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2127.28,1216.96h60.38c36.74,0,60.38,24.01,60.38,60.75v29.83c0,36.74-23.64,60.75-60.38,60.75h-21.83     v103.31h-38.56V1216.96z M2185.85,1331.91c14.91,0,23.65-8.73,23.65-23.64v-31.28c0-14.91-8.73-23.64-23.65-23.64h-20.01v78.57     H2185.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2280.42,1471.6v-254.63h38.56v107.31h45.83v-107.31h38.56v254.63h-38.56v-110.95h-45.83v110.95H2280.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2445.57,1216.96h38.56v254.63h-38.56V1216.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2602.35,1415.21h-41.47l-8.37,56.38h-38.56l42.2-254.63h51.66l42.2,254.63h-39.29L2602.35,1415.21z      M2597.25,1378.11l-15.64-106.58l-15.64,106.58H2597.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1170.23,1726.65h-41.47l-8.37,56.38h-38.56l42.2-254.63h51.66l42.2,254.63h-39.29L1170.23,1726.65z      M1165.14,1689.55l-15.64-106.58l-15.64,106.58H1165.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1244.08,1726.29v-141.14c0-35.65,24.37-60.38,60.38-60.38c36.01,0,60.38,24.74,60.38,60.38v29.83h-37.83     v-29.83c0-14.91-9.09-24.01-22.19-24.01s-22.19,9.09-22.19,24.01v141.14c0,14.91,9.09,24.01,22.19,24.01s22.19-9.09,22.19-24.01     v-36.38h37.83v36.38c0,35.65-24.37,60.38-60.38,60.38C1268.45,1786.67,1244.08,1761.94,1244.08,1726.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1476.16,1726.65h-41.47l-8.37,56.38h-38.56l42.2-254.63h51.65l42.2,254.63h-39.29L1476.16,1726.65z      M1471.07,1689.55l-15.64-106.58l-15.64,106.58H1471.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1553.64,1528.4h60.38c36.74,0,60.38,24.01,60.38,60.75v133.14c0,36.74-23.64,60.75-60.38,60.75h-60.38     V1528.4z M1612.21,1746.66c14.91,0,23.64-8.73,23.64-23.64v-134.59c0-14.91-8.73-23.64-23.64-23.64h-20.01v181.88H1612.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1712.97,1528.4h109.49v36.38h-70.93v70.93h56.38v36.38h-56.38v74.57h70.93v36.38h-109.49V1528.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2030.17,1528.4v254.63h-38.56v-174.61l-36.01,174.61h-26.92l-36.01-174.61v174.61h-37.83V1528.4h54.56     l33.47,162.6l32.01-162.6H2030.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2200.41,1528.4l-51.65,148.05v106.58h-38.56v-106.58l-51.66-148.05h41.11l29.83,97.12l30.56-97.12H2200.41z     "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyceum);
export default __webpack_public_path__ + "static/media/lyceum.ea35302d9efc2e124215ca08362f3df7.svg";
export { ForwardRef as ReactComponent };